import { render, staticRenderFns } from "./ServicesValues.vue?vue&type=template&id=2fbc307b"
import script from "./ServicesValues.vue?vue&type=script&lang=js"
export * from "./ServicesValues.vue?vue&type=script&lang=js"
import style0 from "./ServicesValues.vue?vue&type=style&index=0&id=2fbc307b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports